import script from "./DCStreak.vue?vue&type=script&setup=true&lang=ts"
export * from "./DCStreak.vue?vue&type=script&setup=true&lang=ts"

import "./DCStreak.vue?vue&type=style&index=0&id=177e7912&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-177e7912"]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QDate from 'quasar/src/components/date/QDate.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton,QIcon,QDate});
